const MAX_HISTORY = 50;

const cloneOrg = (org) => ({
  folders: (org?.folders || []).map((f) => ({ ...f })),
  docFolders: { ...(org?.docFolders || {}) },
});

let workspaceId = null;
let undoStack = [];
let redoStack = [];

export const resetDocOrgHistory = (nextWorkspaceId) => {
  if (workspaceId === nextWorkspaceId) return;
  workspaceId = nextWorkspaceId;
  undoStack = [];
  redoStack = [];
};

export const pushDocOrgHistory = (prev) => {
  undoStack.push(cloneOrg(prev));
  if (undoStack.length > MAX_HISTORY) undoStack.shift();
  redoStack = [];
};

export const takeDocOrgUndo = (current) => {
  const prev = undoStack.pop();
  if (!prev) return null;
  redoStack.push(cloneOrg(current));
  return prev;
};

export const takeDocOrgRedo = (current) => {
  const next = redoStack.pop();
  if (!next) return null;
  undoStack.push(cloneOrg(current));
  return next;
};
